import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { formatClientName } from '../../../utils/displayNames';

const getStatusColor = (status) => {
	const normalized = (status || '').toLowerCase();
	switch (normalized) {
		case 'complete':
			return { bg: '#2e7d32', text: '#ffffff' };
		case 'no-show':
		case 'no_show':
			return { bg: '#c62828', text: '#ffffff' };
		case 'waiting':
		case 'scheduled':
		default:
			return { bg: '#3f51b5', text: '#ffffff' };
	}
};

const CalendarEvent = ({ event }) => {
	const appt = event?.resource || {};
	const serviceName = appt?.services?.[0]?.service_name;
	const provider = appt?.user_name;
	const status = appt?.status;
	const { bg, text } = getStatusColor(status);

	// formatClientName returns null for unassigned appointments (client_id is NULL)
	const clientLabel = formatClientName(appt, 'Appointment');
	const isUnassigned = clientLabel === null;

	const displayLabel = isUnassigned ? 'Unassigned Client' : clientLabel;

	const tooltip = [
		isUnassigned ? '⚠️ Unassigned Client' : clientLabel,
		serviceName ? `Service: ${serviceName}` : null,
		provider ? `Provider: ${provider}` : null,
		status ? `Status: ${status}` : null,
	]
		.filter(Boolean)
		.join(' \n');

	return (
		<Box
			sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0 }}
			title={tooltip}
		>
			<Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0, flex: 1 }}>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
					{isUnassigned && (
						<WarningAmberIcon
							sx={{
								fontSize: '0.9rem',
								color: '#ff9800',
								flexShrink: 0
							}}
						/>
					)}
					<Typography
						component="div"
						variant="body2"
						sx={{
							fontWeight: 600,
							lineHeight: 1.1,
							color: isUnassigned ? '#ff9800' : text,
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							fontStyle: isUnassigned ? 'italic' : 'normal'
						}}
					>
						{displayLabel}
					</Typography>
				</Box>
				{(serviceName || provider) && (
					<Typography
						component="div"
						variant="caption"
						sx={{ opacity: 0.9, color: text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
					>
						{[serviceName, provider].filter(Boolean).join(' • ')}
					</Typography>
				)}
			</Box>
			{status && (
				<Chip
					label={status}
					size="small"
					variant="filled"
					sx={{
						ml: 'auto',
						bgcolor: bg,
						color: text,
						height: 18,
						'& .MuiChip-label': { px: 0.75, fontSize: '0.65rem' },
					}}
				/>
			)}
		</Box>
	);
};

export default CalendarEvent;


